import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-brand-cream pt-12 pb-20 px-4 overflow-hidden" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-215">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center md:text-left" data-id="element-216">
            <div className="inline-block bg-brand-gold/20 text-brand-green font-semibold px-4 py-1.5 rounded-full mb-6 text-sm tracking-wide" data-id="element-217">
              PARA MUJERES 40+
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-218">
              Cómo Resetear tu Metabolismo, Eliminar la Grasa Abdominal y
              Recuperar tu Energía en 28 Días...
            </h1>
            <h2 className="text-xl md:text-2xl text-brand-gray/80 font-body mb-4 font-medium" data-id="element-219">
              Sin Contar Una Sola Caloría, Sin Pasar Hambre y Sin Matarte en el
              Gimnasio.
            </h2>
            <p className="text-lg text-brand-gray/70 mb-8 italic border-l-4 border-brand-gold pl-4" data-id="element-220">
              Incluso si sientes que tus hormonas han tomado el control total de
              tu cuerpo.
            </p>

            <div className="mt-8" data-id="element-221">
              <CTAButton data-id="element-222">QUIERO RECUPERAR MI METABOLISMO</CTAButton>
              <p className="text-sm text-brand-gray/60 mt-4 text-center md:text-left" data-id="element-223">
                Acceso inmediato • Pago 100% seguro
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-224">
            {/* Decorative background blob */}
            <div className="absolute inset-0 bg-brand-gold/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-225"></div>
            <img src="https://cdn.magicpatterns.com/uploads/dpGrrqNGnWRXfVFWYLEMH6/Portada.png" alt="El Escudo Hormonal 40+ Ebook y Bonos" className="w-full max-w-lg mx-auto drop-shadow-2xl rounded-xl" data-id="element-226" />
          </motion.div>
        </div>
      </div>
    </section>;
}